/**
 * OTP Agrár Nyeremény játék emailes feliratkozás komponenes
 *
 * @author Erik Bánhalmi @2017.01.12.
 */
import template from './nyeremenyjatek-feliratkozas.pug';
const MODULE_NAME = 'nyeremenyjatekFeliratkozas';
class NyeremenyjatekFeliratkozasController {
	constructor() {
		'ngInject';
	}

	// Beküldjük a megadott adatokat
	submit() {
		let submitObject = {
			object: {
				model: this.model,
				captcha: this.captchaValue
			}
		};
		this.onSubmit(submitObject);
	}
}

export default angular.module(MODULE_NAME, [])
	.component('nyeremenyjatekFeliratkozas', {
		controller: NyeremenyjatekFeliratkozasController,
		template: template(),
		bindings: {
			captcha: '<',
			errors: '<',
			onSubmit: '&'
		}
	}).name;



// WEBPACK FOOTER //
// ./source/applications/nyeremenyjatek-feliratkozas/nyeremenyjatek-feliratkozas.js